import React, { useState } from 'react';
import './PaymentConfirmationModal.css';

const PaymentConfirmationModal = ({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  sessionDetails,
  onDontShowAgainChange,
  actionType = 'confirm' // 'confirm' or 'reserve'
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [understood, setUnderstood] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (understood) {
      onConfirm(dontShowAgain);
    }
  };

  const handleCancel = () => {
    setDontShowAgain(false);
    setUnderstood(false);
    onCancel();
  };

  const handleDontShowAgainChange = (e) => {
    setDontShowAgain(e.target.checked);
    if (onDontShowAgainChange) {
      onDontShowAgainChange(e.target.checked);
    }
  };

  // Calculate session cost
  const calculateSessionCost = () => {
    if (!sessionDetails?.startTime || !sessionDetails?.endTime) return 0;
    
    const parseTime = (timeStr) => {
      const [time, period] = timeStr.split(' ');
      const [hours, minutes] = time.split(':').map(Number);
      let hour24 = hours;
      if (period === 'PM' && hours !== 12) hour24 += 12;
      if (period === 'AM' && hours === 12) hour24 = 0;
      return hour24 * 60 + (minutes || 0);
    };

    const startMinutes = parseTime(sessionDetails.startTime);
    const endMinutes = parseTime(sessionDetails.endTime);
    const durationHours = (endMinutes - startMinutes) / 60;
    
    return (durationHours * 70).toFixed(2);
  };

  const sessionCost = calculateSessionCost();

  return (
    <div className="payment-confirmation-modal-overlay">
      <div className="payment-confirmation-modal">
        <div className="payment-confirmation-modal-header">
          <h2>Payment Confirmation</h2>
          <div className="payment-amount-badge">
            ${sessionCost} CAD
          </div>
        </div>
        
        <div className="payment-confirmation-modal-content">
          <div className="payment-warning-box">
            <div className="warning-content">
              <h3>Payment Information</h3>
              <ul className="payment-details-list">
                <li>
                  <strong>Total for this session:</strong> <strong>${sessionCost} CAD</strong>
                  {sessionDetails && (
                    <span className="session-time-info">
                      {' '}({sessionDetails.startTime} - {sessionDetails.endTime})
                    </span>
                  )}
                </li>
                <li>
                  <strong>Refund Policy:</strong> Sessions are only refundable if cancelled <strong>more than 24 hours</strong> before the start time
                </li>
                <li>
                   Payments are processed securely through Stripe when a reservation is confirmed by the tutor.
                </li>
              </ul>
            </div>
          </div>

          {sessionDetails?.tutorName && (
            <div className="session-details-box">
              <h4>Session Details</h4>
              <p><strong>Tutor:</strong> {sessionDetails.tutorName}</p>
              {sessionDetails.date && (
                <p><strong>Date:</strong> {new Date(sessionDetails.date).toLocaleDateString('en-US', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}</p>
              )}
              {sessionDetails.description && (
                <p><strong>Description:</strong> {sessionDetails.description}</p>
              )}
            </div>
          )}

          <div className="confirmation-checkbox-container">
            <label className="confirmation-checkbox">
              <input
                type="checkbox"
                checked={understood}
                onChange={(e) => setUnderstood(e.target.checked)}
              />
              <span>I understand and agree to the payment terms and refund policy</span>
            </label>
          </div>

          <div className="dont-show-again-container">
            <label className="dont-show-checkbox">
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={handleDontShowAgainChange}
              />
              <span>Don't show this message again</span>
            </label>
          </div>
        </div>

        <div className="payment-confirmation-modal-actions">
          <button 
            className="cancel-button" 
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button 
            className={`confirm-button ${!understood ? 'disabled' : ''}`}
            onClick={handleConfirm}
            disabled={!understood}
          >
            {actionType === 'reserve' ? 'Reserve' : 'Confirm & Pay'} ${sessionCost}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmationModal;